"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
/**
 * @hidden
 */
exports.pagerInfo = 'pager.info';
/**
 * @hidden
 */
exports.pagerFirstPage = 'pager.firstPage';
/**
 * @hidden
 */
exports.pagerPreviousPage = 'pager.previousPage';
/**
 * @hidden
 */
exports.pagerNextPage = 'pager.nextPage';
/**
 * @hidden
 */
exports.pagerLastPage = 'pager.lastPage';
/**
 * @hidden
 */
exports.pagerItemPerPage = 'pager.itemsPerPage';
/**
 * @hidden
 */
exports.pagerPage = 'pager.page';
/**
 * @hidden
 */
exports.pagerOf = 'pager.of';
/**
 * @hidden
 */
exports.pagerTotalPages = 'pager.totalPages';
/**
 * @hidden
 */
exports.filterEqOperator = 'filter.eqOperator';
/**
 * @hidden
 */
exports.filterNotEqOperator = 'filter.notEqOperator';
/**
 * @hidden
 */
exports.filterIsNullOperator = 'filter.isNullOperator';
/**
 * @hidden
 */
exports.filterIsNotNullOperator = 'filter.isNotNullOperator';
/**
 * @hidden
 */
exports.filterIsEmptyOperator = 'filter.isEmptyOperator';
/**
 * @hidden
 */
exports.filterIsNotEmptyOperator = 'filter.isNotEmptyOperator';
/**
 * @hidden
 */
exports.filterStartsWithOperator = 'filter.startsWithOperator';
/**
 * @hidden
 */
exports.filterContainsOperator = 'filter.containsOperator';
/**
 * @hidden
 */
exports.filterNotContainsOperator = 'filter.notContainsOperator';
/**
 * @hidden
 */
exports.filterEndsWithOperator = 'filter.endsWithOperator';
/**
 * @hidden
 */
exports.filterGteOperator = 'filter.gteOperator';
/**
 * @hidden
 */
exports.filterGtOperator = 'filter.gtOperator';
/**
 * @hidden
 */
exports.filterLteOperator = 'filter.lteOperator';
/**
 * @hidden
 */
exports.filterLtOperator = 'filter.ltOperator';
/**
 * @hidden
 */
exports.filterIsTrue = 'filter.isTrue';
/**
 * @hidden
 */
exports.filterIsFalse = 'filter.isFalse';
/**
 * @hidden
 */
exports.filterAfterOrEqualOperator = 'filter.afterOrEqualOperator';
/**
 * @hidden
 */
exports.filterAfterOperator = 'filter.afterOperator';
/**
 * @hidden
 */
exports.filterBeforeOperator = 'filter.beforeOperator';
/**
 * @hidden
 */
exports.filterBeforeOrEqualOperator = 'filter.beforeOrEqualOperator';
/**
 * @hidden
 */
exports.filterAndLogic = 'filter.andLogic';
/**
 * @hidden
 */
exports.filterOrLogic = 'filter.orLogic';
/**
 * @hidden
 */
exports.filterAddExpression = 'filter.addExpression';
/**
 * @hidden
 */
exports.filterAddGroup = 'filter.addGroup';
/**
 * @hidden
 */
exports.filterClose = 'filter.close';
/**
 * @hidden
 */
exports.columnMenuFilterClearButton = 'columnMenu.filterClearButton';
/**
 * @hidden
 */
exports.columnMenuFilterSubmitButton = 'columnMenu.filterSubmitButton';
/**
 * @hidden
 */
exports.columnMenuFilterTitle = 'columnMenu.filterTitle';
/**
 * @hidden
 */
exports.columnMenuSortAscending = 'columnMenu.sortAscending';
/**
 * @hidden
 */
exports.columnMenuSortDescending = 'columnMenu.sortDescending';
/**
 * @hidden
 */
exports.columnMenuFilterEqOperator = 'columnMenu.filterEqOperator';
/**
 * @hidden
 */
exports.columnMenuFilterNotEqOperator = 'columnMenu.filterNotEqOperator';
/**
 * @hidden
 */
exports.columnMenuFilterIsNullOperator = 'columnMenu.filterIsNullOperator';
/**
 * @hidden
 */
exports.columnMenuFilterIsNotNullOperator = 'columnMenu.filterIsNotNullOperator';
/**
 * @hidden
 */
exports.columnMenuFilterIsEmptyOperator = 'columnMenu.filterIsEmptyOperator';
/**
 * @hidden
 */
exports.columnMenuFilterIsNotEmptyOperator = 'columnMenu.filterIsNotEmptyOperator';
/**
 * @hidden
 */
exports.columnMenuFilterStartsWithOperator = 'columnMenu.filterStartsWithOperator';
/**
 * @hidden
 */
exports.columnMenuFilterContainsOperator = 'columnMenu.filterContainsOperator';
/**
 * @hidden
 */
exports.columnMenuFilterNotContainsOperator = 'columnMenu.filterNotContainsOperator';
/**
 * @hidden
 */
exports.columnMenuFilterEndsWithOperator = 'columnMenu.filterEndsWithOperator';
/**
 * @hidden
 */
exports.columnMenuFilterGteOperator = 'columnMenu.filterGteOperator';
/**
 * @hidden
 */
exports.columnMenuFilterGtOperator = 'columnMenu.filterGtOperator';
/**
 * @hidden
 */
exports.columnMenuFilterLteOperator = 'columnMenu.filterLteOperator';
/**
 * @hidden
 */
exports.columnMenuFilterLtOperator = 'columnMenu.filterLtOperator';
/**
 * @hidden
 */
exports.columnMenuFilterIsTrue = 'columnMenu.filterIsTrue';
/**
 * @hidden
 */
exports.columnMenuFilterAfterOrEqualOperator = 'columnMenu.filterAfterOrEqualOperator';
/**
 * @hidden
 */
exports.columnMenuFilterAfterOperator = 'columnMenu.filterAfterOperator';
/**
 * @hidden
 */
exports.columnMenuFilterBeforeOperator = 'columnMenu.filterBeforeOperator';
/**
 * @hidden
 */
exports.columnMenuFilterBeforeOrEqualOperator = 'columnMenu.filterBeforeOrEqualOperator';
/**
 * @hidden
 */
exports.columnMenuFilterAndLogic = 'columnMenu.filterAndLogic';
/**
 * @hidden
 */
exports.columnMenuFilterOrLogic = 'columnMenu.filterOrLogic';
/**
 * @hidden
 */
exports.messages = (_a = {},
    _a[exports.pagerItemPerPage] = 'items per page',
    _a[exports.pagerInfo] = '{0} - {1} of {2} items',
    _a[exports.pagerFirstPage] = 'Go to the first page',
    _a[exports.pagerPreviousPage] = 'Go to the previous page',
    _a[exports.pagerNextPage] = 'Go to the next page',
    _a[exports.pagerLastPage] = 'Go to the last page',
    _a[exports.pagerPage] = 'Page',
    _a[exports.pagerOf] = 'Of',
    _a[exports.pagerTotalPages] = '{0}',
    _a[exports.filterEqOperator] = 'Is equal to',
    _a[exports.filterNotEqOperator] = 'Is not equal to',
    _a[exports.filterIsNullOperator] = 'Is null',
    _a[exports.filterIsNotNullOperator] = 'Is not null',
    _a[exports.filterIsEmptyOperator] = 'Is empty',
    _a[exports.filterIsNotEmptyOperator] = 'Is not empty',
    _a[exports.filterStartsWithOperator] = 'Starts with',
    _a[exports.filterContainsOperator] = 'Contains',
    _a[exports.filterNotContainsOperator] = 'Does not contain',
    _a[exports.filterEndsWithOperator] = 'Ends with',
    _a[exports.filterGteOperator] = 'Is greater than or equal to',
    _a[exports.filterGtOperator] = 'Is greater than',
    _a[exports.filterLteOperator] = 'Is less than or equal to',
    _a[exports.filterLtOperator] = 'Is less than',
    _a[exports.filterIsTrue] = 'Is true',
    _a[exports.filterIsFalse] = 'Is false',
    _a[exports.filterAfterOrEqualOperator] = 'Is after or equal to',
    _a[exports.filterAfterOperator] = 'Is after',
    _a[exports.filterBeforeOperator] = 'Is before',
    _a[exports.filterBeforeOrEqualOperator] = 'Is before or equal to',
    _a[exports.filterAndLogic] = 'And',
    _a[exports.filterOrLogic] = 'Or',
    _a[exports.filterAddExpression] = 'Add Expression',
    _a[exports.filterAddGroup] = 'Add Group',
    _a[exports.filterClose] = 'Close',
    _a[exports.columnMenuFilterClearButton] = 'Clear',
    _a[exports.columnMenuFilterSubmitButton] = 'Filter',
    _a[exports.columnMenuFilterTitle] = 'Filter',
    _a[exports.columnMenuSortAscending] = 'Sort Ascending',
    _a[exports.columnMenuSortDescending] = 'Sort Descending',
    _a[exports.columnMenuFilterEqOperator] = 'Is equal to',
    _a[exports.columnMenuFilterNotEqOperator] = 'Is not equal to',
    _a[exports.columnMenuFilterIsNullOperator] = 'Is null',
    _a[exports.columnMenuFilterIsNotNullOperator] = 'Is not null',
    _a[exports.columnMenuFilterIsEmptyOperator] = 'Is empty',
    _a[exports.columnMenuFilterIsNotEmptyOperator] = 'Is not empty',
    _a[exports.columnMenuFilterStartsWithOperator] = 'Starts with',
    _a[exports.columnMenuFilterContainsOperator] = 'Contains',
    _a[exports.columnMenuFilterNotContainsOperator] = 'Does not contain',
    _a[exports.columnMenuFilterEndsWithOperator] = 'Ends with',
    _a[exports.columnMenuFilterGteOperator] = 'Is greater than or equal to',
    _a[exports.columnMenuFilterGtOperator] = 'Is greater than',
    _a[exports.columnMenuFilterLteOperator] = 'Is less than or equal to',
    _a[exports.columnMenuFilterLtOperator] = 'Is less than',
    _a[exports.columnMenuFilterIsTrue] = 'Is true',
    _a[exports.columnMenuFilterAfterOrEqualOperator] = 'Is after or equal to',
    _a[exports.columnMenuFilterAfterOperator] = 'Is after',
    _a[exports.columnMenuFilterBeforeOperator] = 'Is before',
    _a[exports.columnMenuFilterBeforeOrEqualOperator] = 'Is before or equal to',
    _a[exports.columnMenuFilterAndLogic] = 'And',
    _a[exports.columnMenuFilterOrLogic] = 'Or',
    _a);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/messages/index.js
// module id = 35
// module chunks = 0